/** @format */

import React, { useRef, useState } from 'react';
import style from '../css/HeaderForm.module.css';
// import emailjs from '@emailjs/browser';
// import Swal from 'sweetalert2';
// import ReCAPTCHA from 'react-google-recaptcha';

// import { SiZoom, SiWhatsapp } from 'react-icons/si';
import { MdPlayArrow } from 'react-icons/md';

import paises, { cursos } from '../utils/paises';
import VideoModal from './modals/VideoModal';

import personaje from '../images/header_form.png';
import logo from '../images/logo_dot.png';

const HeaderForm = () => {
	const captcha = useRef(null);
	const [openModal, setOpenModal] = useState(false);
	const [formularioEnviado, setFormularioEnviado] = useState(false);

	const [templateParams, setTemplateParams] = useState({
		FIRSTNAME: '',
		// LASTNAME: '',
		CONTACT_EMAIL: '',
		Country: '',
		CONTACT_CF16: '',
		Phone: '',
		CONTACT_CF3: '',
	});

	// const serviceID = 'service_t4ltjhw';
	// const templateID = 'template_nekhiqv';
	// const publicKey = 'DCgvpZvEmo1MaZGx-';

	const handlerClose = () => {
		setOpenModal(false);
	};

	const handlerSubmit = (event) => {
		event.preventDefault();
		if (formularioEnviado) {
			return;
		}
		setFormularioEnviado(true);

		// emailjs
		// 	.send(serviceID, templateID, templateParams, publicKey)
		// 	.then((res) => {
		// 		console.log('Datos enviados correctamente', res);
		// 		setTemplateParams({
		// 			FIRSTNAME: '',
		// 			// LASTNAME: '',
		// 			CONTACT_EMAIL: '',
		// 			COUNTRY: '',
		// 			CONTACT_CF16: '',
		// 			PHONE: '',
		// 			CONTACT_CF3: '',
		// 		});
		// 		Swal.fire({
		// 			title: '¡Enviado!',
		// 			text: 'Tus datos se han envíado satisfactoriamente',
		// 			icon: 'success',
		// 			confirmButtonText: 'Aceptar',
		// 		});
		// 	})
		// 	.catch((err) =>
		// 		Swal.fire({
		// 			title: 'Error',
		// 			text: 'Error al envíar los datos',
		// 			icon: 'error',
		// 			confirmButtonText: 'Aceptar',
		// 		})
		// 	);

		// if (form.querySelector('#zc_spmSubmit')) {
		// 	form.querySelector('#zc_spmSubmit').remove();
		// }
		// form.submit();

		// setTemplateParams({
		// 	FIRSTNAME: '',
		// 	// LASTNAME: '',
		// 	CONTACT_EMAIL: '',
		// 	COUNTRY: '',
		// 	CONTACT_CF16: '',
		// 	PHONE: '',
		// 	CONTACT_CF3: '',
		// });

		setTimeout(() => {
			setFormularioEnviado(false);
		}, 2000);
	};

	const handlerChange = (event) => {
		const nameProp = event.target.name;
		let valueProp = event.target.value;
		setTemplateParams({ ...templateParams, [nameProp]: valueProp });
	};

	const handlerCountrySelect = (event) => {
		const valueProp = event.target.value;
		const paisActual = paises.find((e) => e.nombre === valueProp);

		if (paisActual) {
			setTemplateParams({
				...templateParams,
				Country: paisActual.nombre,
				Phone: paisActual.ind,
			});
		}
	};

	// function handlerReCAPTCHA(value) {
	// 	console.log('usuario verificado');
	// }

	return (
		<section className={style.header} id='home'>
			<div className={style.containerMain}>
				<div className={style.headerContainer}>
					<div className={style.headerContent}>
						<div className={style.burbuja}>
							<div>
								<img src={logo} alt='logo-libel' />
							</div>
							<h3>
								<b> Certificación</b> Universitaria
							</h3>
						</div>
						<h1 className={style.headerTitle}>
							Disfruta, <b> Crea </b>&
							<br />
							Aprende{' '}
							{/* <span>
								3D ART
								<img
									src='https://react-bitakon.netlify.app/assets/img/icon/slider-stoke-shape.svg'
									alt='line'
									className={style.headerLine}
								/>
							</span> */}
						</h1>

						<p>
							Inicia hoy tu entrenamiento online en vivo desde cualquier parte del mundo, te
							llevamos de cero a niveles avanzados.
						</p>
						<div className={style.headerButtons}>
							<a
								// className='header-button degrade'
								className={`${style.headerButton} ${style.degrade}`}
								href='https://api.whatsapp.com/send?phone=573105868543&text=%F0%9F%94%A5Hola%20Libel%F0%9F%91%8D%2C%20deseo%20informaci%C3%B3n%20de%20los%20entrenamientos%E2%9C%8B'
								// target={'_blank'}
								// rel='noreferrer'
							>
								{/* <SiWhatsapp style={{ fontSize: 20, marginRight: 10 }} /> */}
								Más información
							</a>
							<a
								className={style.headerButton2}
								onClick={() => setOpenModal(true)}
								// href='https://libel.academy/asesoria/'
								// target={'_blank'}
								rel='noreferrer'
							>
								<div className={style.buttonPlay}>
									<MdPlayArrow style={{ fontSize: 28, marginLeft: 2 }} />
								</div>
								Ver video
							</a>
						</div>
					</div>
				</div>

				<div className={style.imgPersonajeContainer}>
					<img src={personaje} alt='personaje zbrush' />
				</div>

				<div className={style.containerForm} id='form'>
					<h1>
						¿Más <span>información?</span>
					</h1>
					<h2>déjanos tus datos y te contactaremos</h2>
					<form
						id='webform4793673000069018067'
						action='https://crm.zoho.com/crm/WebToLeadForm'
						name='WebToLeads4793673000069018067'
						method='POST'
						accept-charset='UTF-8'
					>
						{' '}
						<input
							type='text'
							style={{ display: 'none' }}
							name='xnQsjsdp'
							value='e8416354f43f4248d4eaacc5b390060d7071af7283b31bce89f9b80e11933aa3'
						></input>{' '}
						<input type='hidden' name='zc_gad' id='zc_gad' value=''></input>{' '}
						<input
							type='text'
							style={{ display: 'none' }}
							name='xmIwtLD'
							value='9d549363fb65db5358ab4298cb71429b2944550270625b4beb8cf0b7437d757cfa3e81fc98b708d8eedc84c12f564639'
						></input>
						<input
							type='text'
							style={{ display: 'none' }}
							name='actionType'
							value='TGVhZHM='
						></input>{' '}
						<input
							type='text'
							style={{ display: 'none' }}
							name='returnURL'
							value='https&#x3a;&#x2f;&#x2f;libel.academy&#x2f;mensaje-enviado'
						></input>
						<div className={style.containerInputMain}>
							<div className={style.titleInput}>
								<label for='Last_Name'>
									Nombre Completo<span style={{ color: 'red' }}>*</span>
								</label>
							</div>
							<div className={style.inputContainer}>
								<input
									type='text'
									id='Last_Name'
									name='Last Name'
									placeholder='Tu nombre completo'
									autoComplete='off'
									maxLength='30'
									required
								></input>
							</div>
						</div>
						<div className={style.containerInputMain}>
							<div className={style.titleInput}>
								<label for='Email'>
									Correo electrónico<span style={{ color: 'red' }}>*</span>
								</label>
							</div>
							<div className={style.inputContainer}>
								<input
									type='text'
									ftype='email'
									id='Email'
									autoComplete='off'
									name='Email'
									crmlabel=''
									maxlength='100'
									required
								></input>
								<div class='zcwf_col_help'></div>
							</div>
						</div>
						<div className={style.containerInputMain}>
							<div className={style.titleInput}>
								<label for='Country'>
									País<span style={{ color: 'red' }}>*</span>
								</label>
							</div>
							<div className={style.inputContainer}>
								{/* <input type='text' id='Country' name='Country' maxlength='100'></input> */}
								<select
									id='Country'
									className={templateParams.Country ? style.selected : style.noSelected}
									onChange={handlerCountrySelect}
									value={templateParams.Country ? templateParams.Country : ''}
									changeitem='SIGNUP_FORM_FIELD'
									name='Country'
									type='text'
									required
								>
									<option hidden={true} value=''>
										Selecciona el país
									</option>

									{paises.map((pais, i) => (
										<option key={i} value={pais.nombre}>
											{pais.nombre}
										</option>
									))}
								</select>
							</div>
						</div>
						<div className={style.containerInputMain}>
							<div className={style.titleInput}>
								<label for='Phone'>
									Celular<span style={{ color: 'red' }}>*</span>
								</label>
							</div>
							<div className={style.inputContainer}>
								<input
									type='text'
									id='Phone'
									name='Phone'
									maxlength='30'
									onChange={handlerChange}
									value={templateParams.Phone}
									autoComplete='off'
									maxLength='20'
									required
								></input>
							</div>
						</div>
						<div className={style.containerTextAreaMain}>
							<div className={style.titleTextArea}>
								<label for='LEADCF4'>
									Escribe tu Inquietud <span style={{ color: 'red' }}>*</span>
								</label>
							</div>
							<div className={style.textAreaContainer}>
								<textarea id='LEADCF4' name='LEADCF4' required></textarea>
							</div>
						</div>
						<div class='zcwf_row wfrm_fld_dpNn' style={{ display: 'none' }}>
							<div class='zcwf_col_lab'>
								<label for='Lead_Source'>Fuente de Posible cliente</label>
							</div>
							<div class='zcwf_col_fld'>
								<select class='zcwf_col_fld_slt' id='Lead_Source' name='Lead Source'>
									<option value='-None-'>-None-</option>
									<option value='WhatsApp'>WhatsApp</option>
									<option value='Facebook'>Facebook</option>
									<option value='Instagram'>Instagram</option>
									<option value='Calendly'>Calendly</option>
									<option value='Formulario&#x20;web&#x20;home'>Formulario web home</option>
									<option selected value='Formulario&#x20;web&#x20;m&aacute;ster'>
										Formulario web m&aacute;ster
									</option>
									<option value='Correo'>Correo</option>
									<option value='Importaci&oacute;n'>Importaci&oacute;n</option>
									<option value='Feria&#x20;del&#x20;Libro'>Feria del Libro</option>
									<option value='Curso&#x20;gratuito'>Curso gratuito</option>
									<option value='Evento&#x20;Presencial&#x20;24&#x20;agosto'>
										Evento Presencial 24 agosto
									</option>
								</select>
								<div class='zcwf_col_help'></div>
							</div>
						</div>
						<div class='zcwf_row wfrm_fld_dpNn' style={{ display: 'none' }}>
							<div class='zcwf_col_lab'>
								<label for='LEADCF10'>Asesor</label>
							</div>
							<div class='zcwf_col_fld'>
								<select class='zcwf_col_fld_slt' id='LEADCF10' name='LEADCF10'>
									<option value='-None-'>-None-</option>
									<option value='Gilberto'>Gilberto</option>
									<option value='Juieth'>Juieth</option>
									<option value='Katherine'>Katherine</option>
									<option value='Natalia'>Natalia</option>
									<option value='Sonia'>Sonia</option>
									<option value='Viviana'>Viviana</option>
									<option selected value='Otro'>
										Otro
									</option>
								</select>
								<div class='zcwf_col_help'></div>
							</div>
						</div>
						<div class='zcwf_row wfrm_fld_dpNn' style={{ display: 'none' }}>
							<div class='zcwf_col_lab'>
								<label for='LEADCF12'>Formulario de Ads</label>
							</div>
							<div class='zcwf_col_fld'>
								<input
									type='text'
									id='LEADCF12'
									name='LEADCF12'
									maxlength='255'
									value='Blender&#x20;para&#x20;impresi&oacute;n&#x20;3D'
								></input>
								<div class='zcwf_col_help'></div>
							</div>
						</div>
						<div class='zcwf_col_fld'>
							<div className={style.reCaptchaContainer}>
								<label className={style.checkBox}>
									<input type='checkbox' id='cbox1' value='first_checkbox' required /> Acepto
									las&nbsp;
									<a href='https://libel.academy/politicas-de-privacidad/' target={'_blank'}>
										políticas de privacidad
									</a>
								</label>
							</div>
							<input
								className={formularioEnviado ? style.buttonSubmitDisable : style.buttonSubmit}
								disabled={formularioEnviado}
								type='submit'
								id='formsubmit'
								value='Enviar Solicitud'
								title='Enviar'
							/>

							{/* <input
								type='reset'
								class='zcwf_button'
								name='reset'
								value='Restablecer'
								title='Restablecer'
							/> */}
						</div>
						<script
							id='wf_anal'
							src='https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=cef2bd2d87743441117ce925a79765a812cd912dfacf16b82cac5a9df886130c08a5138403e27b4ca41a354d15e88cb0gidf8eca932838edbcb4ff46c4af30b6e8d9f7c91ac377f15cbdd3df45afdb89fbcgid587dc3eb526de219833b06851bc1e36e2d4deb87863cfa2018b74b3238938a3fgid3300670d3ee4732783fab54e8b6f932864177e3e8b10c9f26e52084215ec10dc&tw=f56d14583d1f3fcb5abdf9c4c09f43343d02b73c32b9ae02be2c70db609359a8'
						></script>
					</form>
					{/* <form
						method='POST'
						id='zcampaignOptinForm'
						action='https://bpxez-zgph.maillist-manage.net/weboptin.zc'
						target='_blank'
						onSubmit={handlerSubmit}
					>
						<div id='SIGNUP_BODY_ALL' name='SIGNUP_BODY_ALL'>
							<div id='SIGNUP_BODY' name='SIGNUP_BODY'>
								<div className={style.containerZoho}>
									<div className={style.containerInputMain}>
										<div name='SIGNUP_FORM_LABEL' className={style.titleInput}>
											<label>
												Nombre completo
												<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
													{' '}
													*
												</span>
											</label>
										</div>
										<div className={style.inputContainer}>
											<input
												onChange={handlerChange}
												type='text'
												name='FIRSTNAME'
												changeitem='SIGNUP_FORM_FIELD'
												value={templateParams.FIRSTNAME}
												placeholder='Tu nombre completo'
												autoComplete='off'
												maxLength='30'
												required
											/>
										</div>
									</div>

									<div className='container-input-main'>
										<div name='SIGNUP_FORM_LABEL' className='title-input'>
											<label>
												Email
												<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
													{' '}
													*
												</span>
											</label>
										</div>
										<div className='input-container'>
											<input
												onChange={handlerChange}
												value={templateParams.CONTACT_EMAIL}
												type='email'
												name='CONTACT_EMAIL'
												changeitem='SIGNUP_FORM_FIELD'
												placeholder='Ingresa tu email'
												autoComplete='off'
												maxLength='50'
												required
											/>
										</div>
									</div>

									<div className='container-input-main'>
										<div name='SIGNUP_FORM_LABEL' className='title-input'>
											<label>
												País
												<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
													{' '}
													*
												</span>
											</label>
										</div>
										<div className='input-container'>
											<select
												className={templateParams.COUNTRY ? 'selected' : 'no-selected'}
												onChange={handlerCountrySelect}
												value={templateParams.COUNTRY ? templateParams.COUNTRY : ''}
												changeitem='SIGNUP_FORM_FIELD'
												name='COUNTRY'
												type='text'
												required
											>
												<option hidden={true} value=''>
													Selecciona el país
												</option>

												{paises.map((pais, i) => (
													<option key={i} value={pais.nombre}>
														{pais.nombre}
													</option>
												))}
											</select>
										</div>
									</div>

									<div className='inputs-phone'>
										<div className='container-input-main-ind'>
											<div name='SIGNUP_FORM_LABEL' className='title-input'>
												<label>
													Ind
													<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
														{' '}
														*
													</span>
												</label>
											</div>
											<div className='input-container-ind'>
												<input
													onChange={handlerChange}
													value={templateParams.CONTACT_CF16}
													type='text'
													name='CONTACT_CF16'
													changeitem='SIGNUP_FORM_FIELD'
													placeholder='ej: +57'
													autoComplete='off'
													maxLength='10'
													required
												/>
											</div>
										</div>

										<div className='container-input-main-cel'>
											<div name='SIGNUP_FORM_LABEL' className='title-input'>
												<label>
													Celular
													<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
														{' '}
														*
													</span>
												</label>
											</div>
											<div className='input-container-cel'>
												<input
													onChange={handlerChange}
													value={templateParams.PHONE}
													type='number'
													name='PHONE'
													changeitem='SIGNUP_FORM_FIELD'
													placeholder='ej: 3101010203'
													autoComplete='off'
													maxLength='50'
													required
												/>
											</div>
										</div>
									</div>

									<div className='container-input-main'>
										<div name='SIGNUP_FORM_LABEL' className='title-input'>
											<label>
												Solicitud
												<span name='SIGNUP_REQUIRED' style={{ color: 'red' }}>
													{' '}
													*
												</span>
											</label>
										</div>
										<div className='input-container'>
											<select
												className={templateParams.CONTACT_CF3 ? 'selected' : 'no-selected'}
												onChange={handlerChange}
												value={templateParams.CONTACT_CF3 ? templateParams.CONTACT_CF3 : ''}
												type='text'
												name='CONTACT_CF3'
												changeitem='SIGNUP_FORM_FIELD'
												required
											>
												<option hidden={true} value='' style={{ color: 'red' }}>
													Selecciona el entrenamiento
												</option>

												{cursos.map((curso, i) => (
													<option key={i} value={curso.nombre}>
														{curso.nombre}
													</option>
												))}
											</select>
										</div>
									</div>

									<div style={{ display: 'none' }} ishidden='true'>
										<div>
											<div name='SIGNUP_FORM_LABEL'>Asesor&nbsp;</div>
											<div class='zcinputbox'>
												<input
													name='CONTACT_CF4'
													changeitem='SIGNUP_FORM_FIELD'
													maxlength='100'
													type='text'
													value='Viviana'
												/>
											</div>
										</div>
									</div>

									<div style={{ display: 'none' }} ishidden='true'>
										<div>
											<div name='SIGNUP_FORM_LABEL'>Fuente de posible cliente&nbsp;</div>
											<div class='zcinputbox'>
												<input
													name='CONTACT_CF5'
													changeitem='SIGNUP_FORM_FIELD'
													maxlength='100'
													type='text'
													value='Formulario web masters'
												/>
											</div>
										</div>
									</div>
								</div>

								<div className={style.reCaptchaContainer}>
									<label className={style.checkBox}>
										<input type='checkbox' id='cbox1' value='first_checkbox' required /> Acepto
										las&nbsp;
										<a href='https://libel.academy/politicas-de-privacidad/' target={'_blank'}>
											políticas de privacidad
										</a>
									</label>
								</div>

								<input
									type='hidden'
									id='secretid'
									value='6LdNeDUUAAAAAG5l7cJfv1AA5OKLslkrOa_xXxLs'
								/>
								<div></div>

								<div>
									<input
										className={formularioEnviado ? style.buttonSubmitDisable : style.buttonSubmit}
										disabled={formularioEnviado}
										type='submit'
										action='Save'
										id='zcWebOptin'
										name='SIGNUP_SUBMIT_BUTTON'
										changetype='SIGNUP_SUBMIT_BUTTON_TEXT'
										value='Enviar Solicitud'
									/>
								</div>
							</div>

							<input type='hidden' id='fieldBorder' value='' onload='' />
							<input
								type='hidden'
								name='zc_trackCode'
								id='zc_trackCode'
								value='ZCFORMVIEW'
								onload=''
							/>
							<input type='hidden' name='viewFrom' id='viewFrom' value='URL_ACTION' />
							<input type='hidden' id='submitType' name='submitType' value='optinCustomView' />
							<input type='hidden' id='lD' name='lD' value='1bb1b38789cb8a3f' />
							<input type='hidden' name='emailReportId' id='emailReportId' value='' />
							<input type='hidden' name='zx' id='cmpZuid' value='12c2f37a7' />
							<input type='hidden' name='zcvers' value='3.0' />
							<input type='hidden' name='oldListIds' id='allCheckedListIds' value='' />
							<input type='hidden' id='mode' name='mode' value='OptinCreateView' />
							<input type='hidden' id='zcld' name='zcld' value='1bb1b38789cb8a3f' />
							<input type='hidden' id='zctd' name='zctd' value='1bb1b38789466029' />
							<input type='hidden' id='document_domain' value='' />
							<input type='hidden' id='zc_Url' value='bpxez-zgph.maillist-manage.net' />
							<input type='hidden' id='new_optin_response_in' value='0' />
							<input type='hidden' id='duplicate_optin_response_in' value='0' />
							<input
								type='hidden'
								id='zc_formIx'
								name='zc_formIx'
								value='3z7dbb597274bb0130518cc92b8e91fd960571b2d4311faa1119821b64da2561af'
							/>
						</div>
						<input type='hidden' id='scriptless' name='scriptless' value='yes' />
						<input type='hidden' id='zc_spmSubmit' name='zc_spmSubmit' value='ZCSPMSUBMIT' />
					</form> */}
				</div>
			</div>
			<VideoModal
				modal={openModal}
				url='https://youtu.be/mRYjBoIwVOQ'
				handlerClose={handlerClose}
			/>
		</section>
	);
};

export default HeaderForm;
